import { DelayCollectionModel } from "../../Model/DelayListCollection";
// Define the initial state for the maintDelays reducer
const initialState = {
  maintDelaysList: [] as DelayCollectionModel[],
  loading: false,
  error: null as string | null,
};


// The maintDelaysReducer function handles actions related to fetching maintenance delays
const maintDelaysReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_MAINT_DELAYS_REQUEST':
      // When a request to fetch maint delays is made, set loading to true and clear any errors
      return { ...state, loading: true, error: null };
    case 'FETCH_MAINT_DELAYS_SUCCESS':
      // When maint delays are successfully fetched, update the maintDelaysList array and set loading to false
      return { ...state, loading: false, maintDelaysList: action.payload, error:null };
    case 'FETCH_MAINT_DELAYS_FAILURE':
      // When there is an error fetching maint delays, set the error message and set loading to false
      return { ...state, loading: false, error: action.payload };
    case 'ADD_MAINT_DELAY': {
      const updatedList = [...state.maintDelaysList, action.payload];
      return {
        ...state,
        maintDelaysList:updatedList,
      };
    }
    case 'UPDATE_MAINT_LIST': {
      return {
        ...state,
        maintDelaysList: action.payload,
      };
    }
    case 'DELETE_MAINT_DELAY': {
      const updatedList = state.maintDelaysList.filter(
        (item) => item.MaintDncId !== action.payload
      );
      return {
        ...state,
        maintDelaysList: updatedList,
      };
    }

    default:
      // For any other action types, return the current state
      return state;
  }
};

export default maintDelaysReducer;
